import type { HBIconType } from '../../../../HBIcon/HBIcon';
import type { HBIconButtonProps } from '../../../../HBIconButton/HBIconButton';
import { HBIconButton } from '../../../../HBIconButton/HBIconButton';
import { gridClasses } from '../../../HBAgGrid.styles';
import { JSX } from 'react';

export interface HBGridToolbarItemProps extends Omit<HBIconButtonProps, 'children' | 'onClick'> {
  icon?: HBIconType | JSX.Element;
  tooltip?: string;
  onClick?: (props: any) => void;
  show?: boolean;
  dataTestId?: string;
}

export function HBGridToolbarItem({
  icon,
  tooltip,
  onClick,
  show = true,
  dataTestId,
  variant,
  ...props
}: HBGridToolbarItemProps): JSX.Element | null {
  if (!show) return null;
  return (
    <HBIconButton
      sx={gridClasses.gridToolbarIcon}
      icon={icon}
      tooltip={tooltip}
      onClick={onClick}
      data-test-id={dataTestId}
      variant={variant}
      {...props}
    />
  );
}
